<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="故障指导"
      width="800px"
      top="5vh"
      @close="faultId = 0">
    <el-button
        type="primary"
        size="mini"
        @click="$refs.editPage.open(faultId, null)">
      新增
    </el-button>
    <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 40px;">
      <el-table-column prop="rowIndex" label="序号"/>
      <el-table-column prop="reason" label="故障原因"/>
      <el-table-column prop="solution" label="解决方案"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="180px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editPage.open(faultId, scope.row)">编辑</el-button>
          <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <fault-guidance-edit ref="editPage" @save-success="getData()"/>
  </el-dialog>
</template>
<script>
  import FaultGuidanceEdit from "@/views/information/Fault/FaultGuidanceEdit.vue";

  export default {
    name:"FaultGuidanceList",
    components: {FaultGuidanceEdit},
    data() {
      return {
        dialogVisible: false,
        faultId: 0,
        tableData: [],
      };
    },
    methods: {
      open(faultId) {
        this.dialogVisible = true;
        if (faultId) {
          this.faultId = faultId;
          this.getData();
        }
      },
      getData() {
        let params = {
          faultId: this.faultId,
        };
        this.$http.get("basic","faultGuidances", params).then((res) => {
          if (res) {
            this.tableData = res;
          } else {
            this.$message.error("获取数据出错");
          }
        });
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","/faultGuidances", row.id).then(() => {
            this.getData();
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
